import React from 'react';
import Button from '../ui/Button';
import './DownloadPageButton.css';


const DownloadPageButton = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="download-page-button-wrapper">
      <Button onClick={handlePrint} className="download-page-button-container">
        Print this page
      </Button>
    </div>
  );
};

export default DownloadPageButton;
